<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <div class="p-5 bg-white">
    <h1 class="font-bold text-gray-800">{{ title }}</h1>
    <slot />
  </div>
</template>
